<template>

<div id="app">

  <div v-if="$isMobile()">
      <div>
      
        <!-- <a class="btn btn-primary" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button"
            aria-controls="offcanvasExample">
            Link with href
          </a> -->
        <!-- <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample">
            Button with data-bs-target
          </button> -->
      
        <div style="width:300px" class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">지역선택</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body">
            <treeselect v-model="selectedCake" :multiple="true" :options="options" placeholder="지역선택하기" :always-open="true"
              :show-count="true" :value-consists-of="valueConsistsOf" :sort-value-by="sortValueBy" :limit="0"
              :limitText='count => `${count}개 시군구 선택됨`' clearAllText="모두 삭제" defaultExpandLevel="0" :max-height="600" />
          </div>
        </div>
      
      
        <!-- <div class="row"> -->
      
        <!-- <div class="col-md-2 bg-light" style="position:fixed;height: 100%;">
            <div class="alert alert-secondary mt-3 ms-2 mb-1 pt-2 pb-2 text-start fs-3" role="alert">
              <b>지역선택</b>
            </div>
              <treeselect class="mt-0 ms-2" v-model="selectedCake" :multiple="true" :options="options" placeholder="지역선택하기" :always-open="true" :show-count="true" :value-consists-of="valueConsistsOf" :sort-value-by="sortValueBy" :limit="0" :limitText='count => `${count}개 시군구 선택됨`' clearAllText="모두 삭제" defaultExpandLevel="0" :max-height="600"/>
            </div> -->
      
      
        <div class="container-fluid">
          <div class="bg-light mt-2 mb-1 text-start" role="alert">
            <!-- <b>아파트투자 분석을 위한 급지표</b> -->
      
      
            <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
              aria-controls="offcanvasExample">
              지역선택하기
            </button>
            <!-- <div class="form-check form-switch float-end">
                <input class="form-check-input" @click="toggleCheckbox" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                <label class="form-check-label" for="flexSwitchCheckChecked">{{ pym2 }}</label>
              </div>
              <div class="form-check form-switch float-end">
                <input class="form-check-input" @click="toggleCheckbox1" type="checkbox" role="switch" id="flexSwitchCheckChecked1">
                <label class="form-check-label" for="flexSwitchCheckChecked1">{{ noise }}</label>
              </div> -->
      
      
            <div class="form-check form-check form-switch float-end ms-4">
              <input class="form-check-input" @click="toggleCheckbox" type="checkbox" role="switch"
                id="flexSwitchCheckChecked" checked>
              <label class="form-check-label" for="flexSwitchCheckChecked">{{ pym2 }}</label>
            </div>
            <div class="form-check form-switch float-end">
              <input class="form-check-input" @click="toggleCheckbox1" type="checkbox" role="switch"
                id="flexSwitchCheckChecked1" disabled>
              <label class="form-check-label" for="flexSwitchCheckChecked1">{{ noise }}</label>
            </div>
      
      
      
      
          </div>
          <div>
      
            <div class="bg-dark text-light text-start p-2"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고
              <div class="float-end">업데이트: {{getFormatDate(updateDate)}} </div>
      
      
      
            </div>
      
      
            <div>
              <vue-good-table :columns="columns_mobie" :rows="filters" :search-options="{enabled: true}">
                <template #table-row="props">
                  <!-- th설정하기
                      <span v-if="props.column.label =='법정동'">
                        <span></span>{{props.column.label}}
                      </span>
                      <span v-else>
                        {{props.column.label}}
                      </span> -->
      
                  <!-- min데이터막대 -->
                  <div v-if="props.column.field == 'min'" style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    <span
                      :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.min / props.row.min_max * 100*0.65}%; background-color: rgba(38, 139, 210, 0.3); text-align: right;`"></span>
                    <span v-if="this.pym2=='평당가'">{{ Math.round(props.row.min).toLocaleString('ko-KR') }}<span
                        class="badge bg-secondary">만원/평</span></span>
                    <span v-else>{{ Math.round(props.row.min/3.3058).toLocaleString('ko-KR') }}<!--span
                        class="badge bg-secondary">만원/㎡</span--></span>
                  </div>
                  <!-- min데이터막대 -->
                  <!-- avg데이터막대 -->
                  <div v-if="props.column.field == 'avg'" style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    <span
                      :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.avg/props.row.avg_max*100}%; background-color: rgba(0, 204, 102, 0.3); text-align: right;`"></span>
                    <span v-if="this.pym2=='평당가'">{{props.row.avg1}}<!--span class="badge bg-secondary">만원/평</span--></span>
                    <span v-else>{{ Math.round(props.row.avg/3.3058).toLocaleString('ko-KR') }}<!--span
                        class="badge bg-secondary">만원/㎡</span--></span>
                  </div>
                  <!-- avg데이터막대 -->
                  <!-- max데이터막대 -->
                  <div v-if="props.column.field == 'max'" style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    <span
                      :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.max/props.row.max_max*100*0.65}%; background-color: rgba(255,102,102, 0.4); text-align: right;`"></span>
                    <span v-if="this.pym2=='평당가'">{{ Math.round(props.row.max).toLocaleString('ko-KR') }}<span
                        class="badge bg-secondary">만원/평</span></span>
                    <span v-else>{{ Math.round(props.row.max/3.3058).toLocaleString('ko-KR') }}<span
                        class="badge bg-secondary">만원/㎡</span></span>
                  </div>
                  <!-- max데이터막대 -->
      
                  <!-- 법정동 -->
                  <div v-if="props.column.field == '법정동'&& props.row.법정동 != '전체'"
                    style="position: relative; min-height: 1.5em; font-size: 0.8em;">
                    <span :style="heatMap(props.row.c_index_1,props.row.c_index)">
                      <span class="ms-1">
                        <span :class="g5(props.row.G5)">
                          {{props.row.G5}}급지
                        </span> {{props.row.법정동}} <span v-if="props.row.avg_rank==1" class="badge bg-success">
                          대장</span><span v-if="(props.row.avg_rank==1)||(props.row.c_index_1 >= 14)"
                          class="badge rounded-pill bg-warning text-dark ms-1">견인</span>
                      </span>
                    </span>
                  </div>
                  <div v-if="props.column.field == '법정동'&& props.row.법정동 == '전체'"
                    style="position: relative; min-height: 1.5em; font-size: 0.8em;">
                    <div style="background-color:yellow">
                      <span class="ms-1">
                        <span :class="g5(props.row.G5)">
                          <!-- {{props.row.G5}}급지 -->
                        </span> <b class="text-danger">{{props.row.sigun2}} {{props.row.법정동}}</b> <span
                          v-if="props.row.avg_rank==1" class="badge bg-success"> {{props.row.sigun2}} 대장</span> <span
                          v-if="(props.row.avg_rank==1)||(props.row.c_index_1 >= 14)"
                          class="badge rounded-pill bg-warning text-dark ms-1">시세견인</span>
                      </span>
                    </div>
                  </div>
                  <!-- 법정동 -->
                  <!-- 5급지분류 -->
                  <div v-if="props.column.field == 'G5'" style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    {{props.row.G5}}
                  </div>
                  <!-- 5급지분류 -->
                  <!-- 단지수 -->
                  <div v-if="props.column.field == 'cnt'" style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    {{props.row.cnt}}
                  </div>
                  <!-- 단지수 -->                  
                  <!-- 시도 -->
                  <div v-if="props.column.field == 'sido2'"
                    style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    {{props.row.sido2}}
                  </div>
                  <!-- 시도 -->
                  <!-- 시군구 -->
                  <div v-if="props.column.field == 'sigun2'"
                    style="position: relative; min-height: 1.5em; text-align: right; font-size: 0.8em;">
                    {{props.row.sigun2}}
                  </div>
                  <!-- 시군구 -->
      
                </template>
              </vue-good-table>
            </div>
            <!-- <div class="bg-dark text-light text-start p-2"><i class="bi bi-code-square"></i> http://ddangzipgo.cafe24app.com
              <div class="float-end">
                업데이트: {{getFormatDate(updateDate)}}</div>
            </div> -->
            <div class="bg-dark text-light text-start p-2"><i class="bi bi-code-square"></i> http://ddangzipgo.cafe24app.com
              <!-- <div class="float-end">
                업데이트: {{getFormatDate(updateDate)}}</div> -->
            </div>
 
          </div>
      
      
        </div>
      
        <!-- </div> -->
      
      </div>
  </div>


  <div v-else>
      <div>
        <div class="row">
          <div class="col-md-2 bg-light" style="position:fixed;height: 100%;">
            <div class="alert alert-secondary mt-3 ms-2 mb-1 pt-2 pb-2 text-start fs-3" role="alert">
              <b>지역선택</b>
            </div>
            <treeselect class="mt-0 ms-2" v-model="selectedCake" :multiple="true" :options="options" placeholder="지역선택하기"
              :always-open="true" :show-count="true" :value-consists-of="valueConsistsOf" :sort-value-by="sortValueBy"
              :limit="0" :limitText='count => `${count}개 시군구 선택됨`' clearAllText="모두 삭제" defaultExpandLevel="0"
              :max-height="600" />
          </div>
      
      
          <div class="col-md-10 offset-md-2">
            <div class="alert alert-secondary mt-3 mb-1 me-4 pt-2 pb-2 text-start fs-3" role="alert">
              <b>아파트투자 분석을 위한 급지표</b>
      
              <!-- <div class="form-check form-switch float-end">
                <input class="form-check-input" @click="toggleCheckbox" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                <label class="form-check-label" for="flexSwitchCheckChecked">{{ pym2 }}</label>
              </div>
              <div class="form-check form-switch float-end">
                <input class="form-check-input" @click="toggleCheckbox1" type="checkbox" role="switch" id="flexSwitchCheckChecked1">
                <label class="form-check-label" for="flexSwitchCheckChecked1">{{ noise }}</label>
              </div> -->
      
      
            </div>
            <div class="mt-0 me-4 mb-2">
      
              <div class="bg-dark text-light text-start p-2"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고
                <!-- <div class="float-end">업데이트: {{getFormatDate(updateDate)}} </div> -->
      
                <div class="form-check form-switch float-end ms-4">
                  <input class="form-check-input" @click="toggleCheckbox" type="checkbox" role="switch"
                    id="flexSwitchCheckChecked" checked>
                  <label class="form-check-label" for="flexSwitchCheckChecked">{{ pym2 }}</label>
                </div>
                <div class="form-check form-switch float-end">
                  <input class="form-check-input" @click="toggleCheckbox1" type="checkbox" role="switch"
                    id="flexSwitchCheckChecked1">
                  <label class="form-check-label" for="flexSwitchCheckChecked1">{{ noise }}</label>
                </div>
      
              </div>
      
      
              <div>
                <vue-good-table :columns="columns" :rows="filters" :search-options="{enabled: true}" :styleClass="styleClass">
                  <template #table-row="props">
      
                    <!-- min데이터막대 -->
                    <div v-if="props.column.field == 'min'" style="position: relative; min-height: 1.5em; text-align: right;">
                      <span
                        :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.min / props.row.min_max * 100*0.65}%; background-color: rgba(38, 139, 210, 0.3); text-align: right;`"></span>
                      <span v-if="this.pym2=='평당가'">{{ Math.round(props.row.min).toLocaleString('ko-KR') }}<span
                          class="badge bg-secondary">만원/평</span></span>
                      <span v-else>{{ Math.round(props.row.min/3.3058).toLocaleString('ko-KR') }}<span
                          class="badge bg-secondary">만원/㎡</span></span>
                    </div>
                    <!-- min데이터막대 -->
                    <!-- avg데이터막대 -->
                    <div v-if="props.column.field == 'avg'" style="position: relative; min-height: 1.5em; text-align: right;">
                      <span
                        :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.avg/props.row.avg_max*100*0.65}%; background-color: rgba(0, 204, 102, 0.3); text-align: right;`"></span>
                      <span v-if="this.pym2=='평당가'">{{props.row.avg1}}<span class="badge bg-secondary">만원/평</span></span>
                      <span v-else>{{ Math.round(props.row.avg/3.3058).toLocaleString('ko-KR') }}<span
                          class="badge bg-secondary">만원/㎡</span></span>
                    </div>
                    <!-- avg데이터막대 -->
                    <!-- max데이터막대 -->
                    <div v-if="props.column.field == 'max'" style="position: relative; min-height: 1.5em; text-align: right;">
                      <span
                        :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${props.row.max/props.row.max_max*100*0.65}%; background-color: rgba(255,102,102, 0.4); text-align: right;`"></span>
                      <span v-if="this.pym2=='평당가'">{{ Math.round(props.row.max).toLocaleString('ko-KR') }}<span
                          class="badge bg-secondary">만원/평</span></span>
                      <span v-else>{{ Math.round(props.row.max/3.3058).toLocaleString('ko-KR') }}<span
                          class="badge bg-secondary">만원/㎡</span></span>
                    </div>
                    <!-- max데이터막대 -->
      
                    <!-- 법정동 -->
                    <div v-if="props.column.field == '법정동'&& props.row.법정동 != '전체'"
                      style="position: relative; min-height: 1.5em;">
                      <span :style="heatMap(props.row.c_index_1,props.row.c_index)">
                        <span class="ms-1">
                          <span :class="g5(props.row.G5)">
                            {{props.row.G5}}급지
                          </span> {{props.row.법정동}} <span v-if="props.row.avg_rank==1" class="badge bg-success">
                            {{props.row.sigun2}} 대장</span> <span v-if="(props.row.avg_rank==1)||(props.row.c_index_1 >= 14)"
                            class="badge rounded-pill bg-warning text-dark ms-1">시세견인</span>
                        </span>
                      </span>
                    </div>
                    <div v-if="props.column.field == '법정동'&& props.row.법정동 == '전체'"
                      style="position: relative; min-height: 1.5em;">
                      <div style="background-color:yellow">
                        <span class="ms-1">
                          <span :class="g5(props.row.G5)">
                            <!-- {{props.row.G5}}급지 -->
                          </span> <b class="text-danger">{{props.row.sigun2}} {{props.row.법정동}}</b> <span
                            v-if="props.row.avg_rank==1" class="badge bg-success"> {{props.row.sigun2}} 대장</span> <span
                            v-if="(props.row.avg_rank==1)||(props.row.c_index_1 >= 14)"
                            class="badge rounded-pill bg-warning text-dark ms-1">시세견인</span>
                        </span>
                      </div>
                    </div>
                    <!-- 법정동 -->
      
                  </template>
                </vue-good-table>
              </div>
              <div class="bg-dark text-light text-start p-2"><i class="bi bi-code-square"></i> http://ddangzipgo.cafe24app.com
                <div class="float-end">
                  업데이트: {{getFormatDate(updateDate)}}</div>
              </div>
              <!-- <table class="table table-bordered border-dark">
                <thead>
                  <tr>
                    <th colspan="7" class="bg-dark text-light text-start"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고<div class="float-end">
                        업데이트: {{getFormatDate(updateDate)}}</div>
                    </th>
                  </tr>
                  <tr class="bg-secondary text-white">
                    <th scope="col" @click="doSort('sido2')">시도<span v-if="(sort.desc) && (sort.field == 'sido2')"><i class="bi float-end bi-sort-down"></i></span><span v-else-if="(sort.desc==false) && (sort.field == 'sido2')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('sigun2')">시군구<span v-if="(sort.desc) && (sort.field == 'sigun2')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == 'sigun2')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('법정동')">읍면동 (급지분류 및 시세견인)<span v-if="(sort.desc) && (sort.field == '법정동')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == '법정동')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('avg')">매매평균평당가<span v-if="(sort.desc) && (sort.field == 'avg')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == 'avg')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('cnt')">단지수<span v-if="(sort.desc) && (sort.field == 'cnt')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == 'cnt')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('G5')">5급지 분류<span v-if="(sort.desc) && (sort.field == 'G5')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == 'G5')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                    <th scope="col" @click="doSort('avg_rank')">시군구내순위<span v-if="(sort.desc) && (sort.field == 'avg_rank')"><i class="bi float-end bi-sort-down"></i></span><span
                      v-else-if="(sort.desc==false) && (sort.field == 'avg_rank')"><i class="bi float-end bi-sort-up"></i></span><span v-else><i
                        class="bi float-end bi-justify"></i></span></th>
                  </tr>
                </thead>
                <tbody v-for="td in sortedData" :key="td">
      
                  <tr v-if="td.법정동 ==='전체'" style="background-color:yellow"  class="text-danger fw-bold">
                    <td>{{td.sido2}}</td>
                    <td>{{td.sigun2}}</td>
                    <td  class="text-start">
                      <div style="position: relative; min-height: 1.5em;">
                        <span>
                          <span class="ms-1">
                            <span :class="g5(td.G5)">
                            </span> {{td.법정동}}
                          </span>
                        </span>
                      </div>
                    </td>
                    <td>
                      <div style="position: relative; min-height: 1.5em;text-align: right;">
                        <span :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${(td.avg / td.max2)*100}%; background-color: rgba(0,204,102, 0.3); text-align: right;`">
                        </span>{{td.avg1}}만원
                      </div>
                    </td>
                    <td>{{td.cnt}}개 단지</td>
                    <td>{{td.G5}} 급지</td>
                    <td>{{td.avg_rank}}</td>
                  </tr>
      
                  
                  <tr v-else>
                    <td>{{td.sido2}}</td>
                    <td>{{td.sigun2}}</td>
                    <td>
                      <div style="position: relative; min-height: 1.5em;">
                        <span :style="heatMap(td.c_index_1,td.c_index)">
                          <span class="ms-1">
                            <span :class="g5(td.G5)">
                              {{td.G5}}급지
                            </span> {{td.법정동}} <span v-if="td.avg_rank==1" class="badge bg-success"> {{td.sigun2}} 대장</span> <span v-if="(td.avg_rank==1)||(td.c_index_1 >= 14)" class="badge rounded-pill bg-warning text-dark ms-1">시세견인</span>
                          </span>
                        </span>
                      </div>
                    </td>
                    <td>
                      <div style="position: relative; min-height: 1.5em;text-align: right;">
                        <span
                          :style="`position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; width: ${(td.avg / td.max2)*100}%; background-color: rgba(0,204,102, 0.3); text-align: right;`">
                        </span>{{td.avg1}}만원
                      </div>
                    </td>
                    <td>{{td.cnt}}개 단지</td>
                    <td>{{td.G5}} 급지</td>
                    <td>{{td.avg_rank}}</td>
                  </tr>
      
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="7" class="border bg-dark text-light"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고</th>
                  </tr>
                </tfoot>
              </table> -->
      
              <!-- <DataTable :columns="columns" :data="filters" class="display compact border" :options="{paging: false, searching:false,info: false}" width="100%">
                <thead>
                  <tr>
                    <th colspan="7" class="border bg-dark text-light"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고<div class="float-end">업데이트: {{getFormatDate(updateDate)}}</div></th>
                  </tr>
                  <tr class="bg-light text-dark">
                    <th class="border">시도</th>
                    <th class="border">시군구</th>
                    <th class="border">읍면동 (급지분류 및 시세견인)</th>
                    <th class="border">매매 평균 평당가</th>
                    <th class="border">단지수</th>
                    <th class="border">5급지 분류</th>
                    
                    <th class="border">시군구내 순위</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th colspan="7" class="border bg-dark text-light"><i class="bi bi-code-square"></i> 부동산빅데이터땅짚고</th>
                  </tr>
                </tfoot>
              </DataTable> -->
            </div>
      
      
          </div>
        </div>
      </div>
  </div>


</div>


</template>

<script>
// import the styles
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';

// import $ from 'jquery/dist/jquery.slim';
// import DataTable from 'datatables.net-vue3/dist/datatables.net-vue.esm';

// import the component
import Treeselect from 'vue3-treeselect'
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'

export default {
  components: {
    Treeselect,
    VueGoodTable,
  },
  computed: {
    // user() {
    //     return this.$store.state.user;
    // },
    // sortedData() {
    //     let data=[];
    //     for (let i = 0; i < this.selectedCake.length; i++) {
    //         data.push(...this.AptGradeList.filter(item => item.지역코드 === this.selectedCake[i]))
    //     }

    //     let dataList = [];
    //     for (let i = 0; i < data.length; i++) {
    //         dataList.push(Number(data[i].avg))
    //     }      
    //     let max = Math.max(...dataList)   
    //     let AptGradeList2 = [];
    //     for (let i = 0; i < data.length; i++) {

    //         let avg1 = Math.round(data[i].avg).toLocaleString('ko-KR')
    //         data[i]['avg1']= avg1

    //         data[i]['max2']= max
    //         // console.log(data[i])
    //         AptGradeList2.push(data[i])
    //         // console.log(AptGradeList[i].min)
    //         // this.AptGradeList = AptGradeList;
    //     }    
    //     if(!this.sort.field){
    //         return AptGradeList2
    //     }
       

    //     return AptGradeList2.concat().sort((a,b)=>{
    //         if(this.sort.desc){
    //             return a[this.sort.field] > b[this.sort.field] ? -1:1        
    //         }else{
    //             return a[this.sort.field] > b[this.sort.field] ? 1:-1                  
    //         }

    //         //버튼을 눌렀을 때 작동된다. 2개 필드 컬럼 소팅
    //         // if (a.G5 < b.G5) return -1;
    //         // if (a.G5 > b.G5) return 1;
    //         // if (a.avg > b.avg) return -1;
    //         // if (a.avg < b.avg) return 1;            

    //         // if(this.sort.desc){
    //         //     if(a[this.sort.field] > b[this.sort.field]) {
    //         //       return -1
    //         //     }else{
    //         //       return 1
    //         //     }      
    //         // }else{
    //         //     if(a[this.sort.field] > b[this.sort.field]) {
    //         //       return 1
    //         //     }else{
    //         //       return -1
    //         //     }                 
    //         // }

    //     })
    // },      
    filters() {
    
      let data=[];
      for (let i = 0; i < this.selectedCake.length; i++) {
          data.push(...this.AptGradeList.filter(item => item.지역코드 === this.selectedCake[i]))
      }
      // console.log(data)      
      // let data = this.AptGradeList.filter(item => item.sigun2 === this.selectedCake[0]);
      let dataList = [];
      let dataList_min = [];
      let dataList_max = [];

      for (let i = 0; i < data.length; i++) {
          dataList.push(Number(data[i].avg))
          dataList_min.push(Number(data[i].min))
          dataList_max.push(Number(data[i].max))

      }      
      let avg_max = Math.max(...dataList)
      let min_max = Math.max(...dataList_min)      
      let max_max = Math.max(...dataList_max)      

      // console.log(max);
      let AptGradeList2 = [];
      for (let i = 0; i < data.length; i++) {
          let avg1 = Math.round(data[i].avg).toLocaleString('ko-KR')
          data[i]['avg1']= avg1
          data[i]['avg_max']= avg_max
          data[i]['min_max']= min_max
          data[i]['max_max']= max_max

          // console.log(data[i])
          AptGradeList2.push(data[i])
          // console.log(AptGradeList[i].min)
          // this.AptGradeList = AptGradeList;
      }   
      return AptGradeList2
    }        
  },  
  mounted() {
  },
  created() {
      // this.sido = this.$route.params.sido;
      // this.sigun = this.$route.params.sigun;
      
      this.getAptGradeList();
      this.getSidoList();
      this.getSigunList();
      this.getSigunList1();
  },  
  data() {
    return{
      AptGradeList: [],
      SidoList: [],
      SigunList: [],
      SigunList1: [],
      DongList: [],
      Sigun1: [],
      Sigun2: [],
      Sigun3: [],
      sido: "경상남도",
      sigun: "진주시",
      sigun2: "진주시",
      dong: "",
      myNum:30,
      avgMax:"",
      selectedCake: [48170],         

      value: null,
      sort: {
          field: 'avg',
          desc: true        
      },    

      options: [{'id': 11, 'label': '서울특별시', 'children': [{'id': 11110, 'label': '종로구'}, {'id': 11140, 'label': '중구'}, {'id': 11170, 'label': '용산구'}, {'id': 11200, 'label': '성동구'}, {'id': 11215, 'label': '광진구'}, {'id': 11230, 'label': '동대문구'}, {'id': 11260, 'label': '중랑구'}, {'id': 11290, 'label': '성북구'}, {'id': 11305, 'label': '강북구'}, {'id': 11320, 'label': '도봉구'}, {'id': 11350, 'label': '노원구'}, {'id': 11380, 'label': '은평구'}, {'id': 11410, 'label': '서대문구'}, {'id': 11440, 'label': '마포구'}, {'id': 11470, 'label': '양천구'}, {'id': 11500, 'label': '강서구'}, {'id': 11530, 'label': '구로구'}, {'id': 11545, 'label': '금천구'}, {'id': 11560, 'label': '영등포구'}, {'id': 11590, 'label': '동작구'}, {'id': 11620, 'label': '관악구'}, {'id': 11650, 'label': '서초구'}, {'id': 11680, 'label': '강남구'}, {'id': 11710, 'label': '송파구'}, {'id': 11740, 'label': '강동구'}]}, {'id': 41, 'label': '경기도', 'children': [{'id': 41290, 'label': '과천시'}, {'id': 41171, 'label': '안양시 만안구'}, {'id': 41173, 'label': '안양시 동안구'}, {'id': 41131, 'label': '성남시 수정구'}, {'id': 41133, 'label': '성남시 중원구'}, {'id': 41135, 'label': '성남시 분당구'}, {'id': 41410, 'label': '군포시'}, {'id': 41430, 'label': '의왕시'}, {'id': 41550, 'label': '안성시'}, {'id': 41461, 'label': '용인시 처인구'}, {'id': 41463, 'label': '용인시 기흥구'}, {'id': 41465, 'label': '용인시 수지구'}, {'id': 41111, 'label': '수원시 장안구'}, {'id': 41113, 'label': '수원시 권선구'}, {'id': 41115, 'label': '수원시 팔달구'}, {'id': 41117, 'label': '수원시 영통구'}, {'id': 41190, 'label': '부천시'}, {'id': 41271, 'label': '안산시 상록구'}, {'id': 41273, 'label': '안산시 단원구'}, {'id': 41390, 'label': '시흥시'}, {'id': 41210, 'label': '광명시'}, {'id': 41590, 'label': '화성시'}, {'id': 41370, 'label': '오산시'}, {'id': 41220, 'label': '평택시'}, {'id': 41360, 'label': '남양주시'}, {'id': 41310, 'label': '구리시'}, {'id': 41450, 'label': '하남시'}, {'id': 41610, 'label': '광주시'}, {'id': 41500, 'label': '이천시'}, {'id': 41670, 'label': '여주시'}, {'id': 41570, 'label': '김포시'}, {'id': 41281, 'label': '고양시 덕양구'}, {'id': 41285, 'label': '고양시 일산동구'}, {'id': 41287, 'label': '고양시 일산서구'}, {'id': 41480, 'label': '파주시'}, {'id': 41650, 'label': '포천시'}, {'id': 41250, 'label': '동두천시'}, {'id': 41630, 'label': '양주시'}, {'id': 41150, 'label': '의정부시'}]}, {'id': 28, 'label': '인천광역시', 'children': [{'id': 28110, 'label': '중구'}, {'id': 28140, 'label': '동구'}, {'id': 28177, 'label': '미추홀구'}, {'id': 28185, 'label': '연수구'}, {'id': 28200, 'label': '남동구'}, {'id': 28237, 'label': '부평구'}, {'id': 28245, 'label': '계양구'}, {'id': 28260, 'label': '서구'}]}, {'id': 26, 'label': '부산광역시', 'children': [{'id': 26110, 'label': '중구'}, {'id': 26140, 'label': '서구'}, {'id': 26170, 'label': '동구'}, {'id': 26200, 'label': '영도구'}, {'id': 26230, 'label': '부산진구'}, {'id': 26290, 'label': '남구'}, {'id': 26470, 'label': '연제구'}, {'id': 26500, 'label': '수영구'}, {'id': 26350, 'label': '해운대구'}, {'id': 26410, 'label': '금정구'}, {'id': 26260, 'label': '동래구'}, {'id': 26710, 'label': '기장군'}, {'id': 26320, 'label': '북구'}, {'id': 26440, 'label': '강서구'}, {'id': 26530, 'label': '사상구'}, {'id': 26380, 'label': '사하구'}]}, {'id': 27, 'label': '대구광역시', 'children': [{'id': 27110, 'label': '중구'}, {'id': 27140, 'label': '동구'}, {'id': 27170, 'label': '서구'}, {'id': 27200, 'label': '남구'}, {'id': 27230, 'label': '북구'}, {'id': 27260, 'label': '수성구'}, {'id': 27290, 'label': '달서구'}, {'id': 27710, 'label': '달성군'}]}, {'id': 29, 'label': '광주광역시', 'children': [{'id': 29110, 'label': '동구'}, {'id': 29140, 'label': '서구'}, {'id': 29155, 'label': '남구'}, {'id': 29170, 'label': '북구'}, {'id': 29200, 'label': '광산구'}]}, {'id': 30, 'label': '대전광역시', 'children': [{'id': 30110, 'label': '동구'}, {'id': 30140, 'label': '중구'}, {'id': 30170, 'label': '서구'}, {'id': 30200, 'label': '유성구'}, {'id': 30230, 'label': '대덕구'}]}, {'id': 31, 'label': '울산광역시', 'children': [{'id': 31110, 'label': '중구'}, {'id': 31140, 'label': '남구'}, {'id': 31170, 'label': '동구'}, {'id': 31200, 'label': '북구'}, {'id': 31710, 'label': '울주군'}]}, {'id': 36, 'label': '세종특별자치시', 'children': [{'id': 36110, 'label': '세종시'}]}, {'id': 42, 'label': '강원도', 'children': [{'id': 42110, 'label': '춘천시'}, {'id': 42130, 'label': '원주시'}, {'id': 42150, 'label': '강릉시'}, {'id': 42170, 'label': '동해시'}, {'id': 42190, 'label': '태백시'}, {'id': 42210, 'label': '속초시'}, {'id': 42230, 'label': '삼척시'}]}, {'id': 43, 'label': '충청북도', 'children': [{'id': 43111, 'label': '청주시 상당구'}, {'id': 43112, 'label': '청주시 서원구'}, {'id': 43113, 'label': '청주시 흥덕구'}, {'id': 43114, 'label': '청주시 청원구'}, {'id': 43130, 'label': '충주시'}, {'id': 43150, 'label': '제천시'}, {'id': 43770, 'label': '음성군'}]}, {'id': 44, 'label': '충청남도', 'children': [{'id': 44131, 'label': '천안시 동남구'}, {'id': 44133, 'label': '천안시 서북구'}, {'id': 44150, 'label': '공주시'}, {'id': 44180, 'label': '보령시'}, {'id': 44200, 'label': '아산시'}, {'id': 44210, 'label': '서산시'}, {'id': 44230, 'label': '논산시'}, {'id': 44250, 'label': '계룡시'}, {'id': 44800, 'label': '홍성군'}, {'id': 44810, 'label': '예산군'}, {'id': 44270, 'label': '당진시'}]}, {'id': 45, 'label': '전라북도', 'children': [{'id': 45111, 'label': '전주시 완산구'}, {'id': 45113, 'label': '전주시 덕진구'}, {'id': 45130, 'label': '군산시'}, {'id': 45140, 'label': '익산시'}, {'id': 45180, 'label': '정읍시'}, {'id': 45190, 'label': '남원시'}, {'id': 45210, 'label': '김제시'}]}, {'id': 46, 'label': '전라남도', 'children': [{'id': 46110, 'label': '목포시'}, {'id': 46130, 'label': '여수시'}, {'id': 46150, 'label': '순천시'}, {'id': 46170, 'label': '나주시'}, {'id': 46230, 'label': '광양시'}, {'id': 46840, 'label': '무안군'}]}, {'id': 47, 'label': '경상북도', 'children': [{'id': 47130, 'label': '경주시'}, {'id': 47190, 'label': '구미시'}, {'id': 47111, 'label': '포항시 남구'}, {'id': 47113, 'label': '포항시 북구'}, {'id': 47150, 'label': '김천시'}, {'id': 47170, 'label': '안동시'}, {'id': 47210, 'label': '영주시'}, {'id': 47230, 'label': '영천시'}, {'id': 47250, 'label': '상주시'}, {'id': 47280, 'label': '문경시'}, {'id': 47290, 'label': '경산시'}, {'id': 47850, 'label': '칠곡군'}]}, {'id': 48, 'label': '경상남도', 'children': [{'id': 48121, 'label': '창원시 의창구'}, {'id': 48123, 'label': '창원시 성산구'}, {'id': 48125, 'label': '창원시 마산합포구'}, {'id': 48127, 'label': '창원시 마산회원구'}, {'id': 48129, 'label': '창원시 진해구'}, {'id': 48170, 'label': '진주시'}, {'id': 48220, 'label': '통영시'}, {'id': 48240, 'label': '사천시'}, {'id': 48250, 'label': '김해시'}, {'id': 48270, 'label': '밀양시'}, {'id': 48310, 'label': '거제시'}, {'id': 48330, 'label': '양산시'}]}, {'id': 50, 'label': '제주특별자치도', 'children': [{'id': 50110, 'label': '제주시'}, {'id': 50130, 'label': '서귀포시'}]}],

      valueConsistsOf: 'LEAF_PRIORITY',
      sortValueBy: 'LEVEL',
      updateDate: "",
      blueList:['#f2f2ff', '#e6e6ff', '#d9d9ff', '#ccccff', '#bfbfff', '#b2b2ff', '#a6a6ff', '#9999ff', '#8c8cff', '#8080ff', '#7373ff', '#6666ff', '#5959ff', '#4d4dff', '#4040ff', '#3333ff', '#2626ff', '#1919ff', '#0d0dff', '#0000ff'],
      redList:['#fff2f2', '#ffe6e6', '#ffd9d9', '#ffcccc', '#ffbfbf', '#ffb2b2', '#ffa6a6', '#ff9999', '#ff8c8c', '#ff8080', '#ff7373', '#ff6666', '#ff5959', '#ff4d4d', '#ff4040', '#ff3333', '#ff2626', '#ff1919', '#ff0d0d', '#ff0000'],    
      
      //vue-good-table-next
      columns: [
        {
          label: '시도',
          field: 'sido2',
        },
        {
          label: '시군구',
          field: 'sigun2',
          // type: 'number',
        },
        {
          label: '읍면동 (급지분류 및 시세견인)',
          field: '법정동',
          // type: 'date',
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM do yy',
        },
        {
          label: '최소매매가',
          field: 'min',
          hidden: true,          
          type: 'number',
        },
        {
          label: '평균매매가',
          field: 'avg',
          type: 'number',
        }, 
        {
          label: '최대매매가',
          field: 'max',
          hidden: true,          
          type: 'number',
        },                   
        {
          label: '단지수',
          field: 'cnt',
          type: 'number',
        },
        {
          label: '5급지 분류',
          field: 'G5',
          // hidden: true,
          type: 'number',
        },
        {
          label: '시군구내순위',
          field: 'avg_rank',
          hidden: true,          
          type: 'number',
        },                        
      ],
      columns_mobie: [
        // {
        //   label: '시도',
        //   field: 'sido2',
        // },
        {
          label: '시군구',
          field: 'sigun2',
          // type: 'number',
        },
        {
          label: '동(대장,시세견인)',
          field: '법정동',
          // type: 'date',
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM do yy',
        },
        {
          label: 'min',
          field: 'min',
          hidden: true,          
          type: 'number',
        },
        {
          label: 'avg',
          field: 'avg',
          type: 'number',
        }, 
        {
          label: 'max',
          field: 'max',
          hidden: true,          
          type: 'number',
        },                   
        {
          label: '단지수',
          field: 'cnt',
          type: 'number',
        },
        // {
        //   label: '5급지',
        //   field: 'G5',
        //   // hidden: true,
        //   type: 'number',
        // },
        // {
        //   label: '시군구내순위',
        //   field: 'avg_rank',
        //   hidden: true,          
        //   type: 'number',
        // },                        
      ],      
      rows: [
        { id:1, name:"John", age: 20, createdAt: '',score: 0.03343 },
        { id:2, name:"Jane", age: 24, createdAt: '2011-10-31', score: 0.03343 },
        { id:3, name:"Susan", age: 16, createdAt: '2011-10-30', score: 0.03343 },
        { id:4, name:"Chris", age: 55, createdAt: '2011-10-11', score: 0.03343 },
        { id:5, name:"Dan", age: 40, createdAt: '2011-10-21', score: 0.03343 },
        { id:6, name:"John", age: 20, createdAt: '2011-10-31', score: 0.03343 },
      ],
      // vue-good-table-next      

      checkbox: false,
      checkbox1: false,

      pym2: '평당가',
      noise: '노이즈OFF',

      styleClass: 'vgt-table bordered fs-6',
    };
  },
  methods: {
    getavgMax() {
      let dataList = [];
      for (let i = 0; i < this.filters.length; i++) {
          dataList.push(Number(this.filters[i].avg))
      }
      this.avgMax = Math.max(...dataList)      
      // console.log(this.filters);
    },
    async getAptGradeList() {
        let AptGradeList = await this.$api("/api/AptGradeList",'post',{})
        this.AptGradeList = AptGradeList;
        this.updateDate = new Date(this.AptGradeList[0].create_at);        

        // let year = updateDate.getFullYear();
        // let month = (1 + updateDate.getMonth());
        // let day = updateDate.getDate();

        // this.updateDate = `${year}년 ${month}월 ${day}일 `; //Template literals 이용
        // alert(this.updateDate)
    },    
    async getSidoList() {
        let SidoList = await this.$api("/api/SidoList",'post', {});
        this.SidoList = SidoList;
    },
    async getSigunList() {
        let SigunList = await this.$api("/api/SigunList",'post', {});
        this.SigunList = SigunList;
    },
    async getSigunList1() {
        let SigunList1 = await this.$api("/api/SigunList1",'post', { param: [this.sido] });
        this.SigunList1 = SigunList1;
    },
    changeSido() {
        // this.$router.push({ path: '/agt' });
        this.sido = '대구광역시';
        this.getUsers();
    },
    changeSigun() {
        // console.log(a)
        this.$router.push({ path: '/agt'});
    },
    showAlert() {
      this.$swal.fire({
          icon: 'warning',
          title: '로그인이 필요합니다.',
      });
    },
    showAlert_login() {
      this.$swal.fire({
        // position: 'bottom-end',
        icon: 'success',
        title: '로그인 되었습니다.',
        showConfirmButton: false,
        timer: 1500
      });    
    },
    showAlert_logout() {
      this.$swal.fire({
        // position: 'bottom-end',
        icon: 'success',
        title: '로그아웃 되었습니다.',
        showConfirmButton: false,
        timer: 1500
      });    
    },    
    showAlert_NoUser() {
      this.$swal.fire({
        // position: 'bottom-end',
        icon: 'success',
        title: '사용권한이 없습니다.',
        showConfirmButton: false,
        timer: 1500
      });    
    },    
    sidoChange() {
      this.sigun='구미시';
    },

    changeMode() {
      this.modeBool = !this.modeBool;
      this.config.checkMode = this.modeBool ? 0 : 1;
    },

    getFormatDate(date) {
      const year = date.getFullYear();
      const month = (1 + date.getMonth());
      const day = date.getDate();
      return `${year}년 ${month}월 ${day}일 `; //Template literals 이용
    },
    doSort(field) {
        if(field == this.sort.field){
            this.sort.desc = !this.sort.desc
        }else{
            this.sort.field = field;
            this.sort.desc = true;
        }
    },
    heatMap(c_index_1,c_index) {
   
      if(c_index_1 > 0){
        if(c_index < 14) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.redList[c_index]}; color:black; text-align:left;`
        } else{
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.redList[c_index]}; color:white; text-align:left;`          
        }
      } else if(c_index_1 < 0) {
        if(c_index <= 8) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.blueList[c_index]}; color:black; text-align:left;`
        } else if(c_index > 8) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.blueList[c_index]}; color:white; text-align:left;`          
        }
      }
    },
    g5(c) {
      if(c === 1){
        return `badge bg-dark`
      } else if(c === 2) {
        return `badge bg-primary`
      } else if(c === 3) {
        return `badge bg-info text-dark`
      } else if(c === 4) {
        return `badge bg-secondary`
      } else if(c === 5) {
        return `badge bg-danger`
      }
    },
    toggleCheckbox() {
      this.checkbox = !this.checkbox
      if(this.checkbox==false) {
        this.pym2='평당가';
        // this.columns[6].hidden = false;
      } else {
        this.pym2='㎡당가';
        // this.columns[6].hidden = true;
      }
      // this.$emit('setCheckboxVal', this.checkbox)
    },
    toggleCheckbox1() {
      this.checkbox1 = !this.checkbox1
      if(this.checkbox1==false) {
        this.noise='노이즈OFF';
        this.columns[3].hidden = true;
        this.columns[5].hidden = true;
        this.columns[8].hidden = true;
        this.styleClass ='vgt-table bordered fs-6';        
      } else {
        this.noise='노이즈ON';
        this.columns[3].hidden = false;
        this.columns[5].hidden = false;
        this.columns[8].hidden = false;
        this.styleClass ='vgt-table bordered fs-6';        
      }

    },    
  
  },
  
};

</script>

<style scoped>
td {
  padding: 4px;
}

</style>